module.exports = __webpack_public_path__ + "media/wood_4.28492c36.mp3";